<template>
  <div class="room-quantity">
    <label>{{ $t('h4h.roomNum') }}</label>
    <div class="counter">
      <span
        id="subtractRoom"
        :class="[disableSubtraction ? 'disable' : '', 'subtract']"
        @click="updateQuantity(-1, 'subtract')"
      />
      <span
        id="numberOfRooms"
        class="number-of-rooms"
      >
        {{ quantity }}
      </span>
      <span
        id="addRoom"
        :class="[disableAddition() ? 'disable' : '', 'add']"
        @click="updateQuantity(1, 'add')"
      />
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  props: {
    contracted: {
      default: false,
      type: Boolean
    }
  },

  computed: {
    quantity() {
      return this.$store.state.hotel.roomQty
    },
    disableSubtraction() {
      return this.quantity < 2
    }
  },

  methods: {
    ...mapMutations('hotel', ['updateRoomQty','increaseRoomQty']),

    packageQty() {
      if(document.getElementById('itemAmount') != null ) {
        return parseInt(document.getElementById('itemAmount').textContent, 10)
      } else {
        return this.$store.state.packages.packageQty
      }
    },
    disableAddition() {
      if (this.contracted) {
        return this.quantity >= this.packageQty()
      } else {
        return false
      }
    },
    updateQuantity(value, operation) {
      if ( operation =='add' && this.quantity == this.packageQty()-1 ) {
        document.getElementById('addRoom').classList.add('disable')
      }

      if ( operation =='subtract' ) {
        if (document.getElementById('addRoom').classList.contains('disable')){
          console.log('SHOULD REMOVE')
          document.getElementById('addRoom').classList.remove('disable')
        }
      }

      switch (operation) {
      case 'add':
        if (!this.disableAddition()) {
          this.increaseRoomQty(value)
        }
        break

      case 'subtract':
        if (!this.disableSubtraction) {
          this.increaseRoomQty(value)
        }
        break
      }
    }
  }
}
</script>
